/**
 * Tests on the decimal strings the API sends (numeric(18,6) as text), with no
 * arithmetic: money is never turned into a floating-point number here.
 */

/** "0", "0.000000", "-0.00": the string is a zero. Anything else is not. */
export function isZeroDecimal(value: string | null | undefined): boolean {
  return typeof value === "string" && /^-?0+(\.0+)?$/.test(value);
}
